<template>
    <CustomDialog
        :value="value"
        @input="$emit('input', $event)"
        :defaultTitle="modalTitle"
        :heightClass="`ppv2-max-h-[85vh]`"
        height="65%"
        centerContent
    >
        <template #content>
            <div class="ppv2-grid ppv2-grid-cols-1" :style="{ gap: normalizeSize(16, true) }">
                <!-- Name -->
                <BaseInput
                    v-model="groupForm.name"
                    label="Nom du groupe"
                    placeholder="Ex : Clients VIP, Fidélité..."
                    required
                    classContainerAdd="ppv2-w-full"
                    :error="errors.name ? errors.name[0] : null"
                />
            </div>

            <div class="ppv2-grid ppv2-grid-cols-2 ppv2-mt-4" :style="{ gap: normalizeSize(16, true) }">
                <!-- Owner -->
                <BaseSelect
                    v-model="groupForm.owner_id"
                    label="Propriétaire du groupe"
                    placeholder="Sélectionnez un propriétaire"
                    :options="customers"
                    optionLabel="name"
                    optionValue="id"
                    required
                    :error="errors.owner_id ? errors.owner_id[0] : null"
                    classAdded="borderInput"
                    fixed-dropdown
                />

                <!-- Status -->
                <div class="isNotrequired">
                    <BaseLabel label="État" />
                    <div class="ppv2-mt-2">
                        <button
                            @click="groupForm.active = !groupForm.active"
                            class="ppv2-inline-flex ppv2-items-center ppv2-gap-3 ppv2-px-4 ppv2-py-2 ppv2-rounded-xl ppv2-border ppv2-transition-all"
                            :class="
                                groupForm.active
                                    ? 'ppv2-border-[#206A64] ppv2-bg-[#06B217] ppv2-bg-opacity-20'
                                    : 'ppv2-border-[#4E4E4E] ppv2-bg-[#474747] ppv2-bg-opacity-20'
                            "
                        >
                            <div
                                class="ppv2-w-10 ppv2-h-5 ppv2-rounded-full ppv2-flex ppv2-items-center ppv2-transition-all"
                                :class="
                                    groupForm.active
                                        ? 'ppv2-bg-[#206A64] ppv2-justify-end'
                                        : 'ppv2-bg-[#4E4E4E] ppv2-justify-start'
                                "
                            >
                                <div class="ppv2-w-4 ppv2-h-4 ppv2-bg-white ppv2-rounded-full ppv2-mx-0.5"></div>
                            </div>
                            <span class="poppinsRegular ppv2-text-gray-700">
                                {{ groupForm.active ? 'Activé' : 'Désactivé' }}
                            </span>
                        </button>
                    </div>
                </div>
            </div>

            <div class="ppv2-grid ppv2-grid-cols-1 ppv2-mt-4" :style="{ gap: normalizeSize(16, true) }">
                <!-- Customers -->
                <BaseSelect
                    v-model="groupForm.customer_ids"
                    label="Clients membres"
                    placeholder="Ajouter des clients..."
                    :options="customers"
                    optionLabel="name"
                    optionValue="id"
                    multiple
                    required
                    :error="errors.customer_ids ? errors.customer_ids[0] : null"
                    classAdded="borderInput"
                    fixed-dropdown
                />
            </div>
        </template>
        <template #actions>
            <BaseButton variant="outline" @click="$emit('input', false)" :customClass="`!ppv2-h-[45px] !ppv2-min-w-[170px]`">
                {{ $t('common.cancel') }}
            </BaseButton>
            <BaseButton
                variant="primary"
                @click="$emit('save')"
                :customClass="`!ppv2-h-[45px] !ppv2-min-w-[170px] !ppv2-bg-[#7D2DBD]`"
                :disabled="isSaving"
            >
                {{ isSaving ? $t('common.saving') : isEditMode ? $t('common.validate') : $t('common.add') }}
            </BaseButton>
        </template>
    </CustomDialog>
</template>

<script>
import normalizeSize from '../../../../utils/normalizeSize'

import BaseButton from '../../../Shared/BaseButton.vue'
import BaseInput from '../../../Shared/BaseInput.vue'
import BaseSelect from '../../../Shared/BaseSelect.vue'
import BaseLabel from '../../../Shared/BaseLabel.vue'
import CustomDialog from '../../../Shared/CustomDialog.vue'

export default {
    name: 'GroupModal',
    components: {
        BaseButton,
        BaseInput,
        BaseSelect,
        BaseLabel,
        CustomDialog,
    },
    props: {
        value: { type: Boolean, required: true },
        isEditMode: { type: Boolean, default: false },
        isSaving: { type: Boolean, default: false },
        groupForm: { type: Object, required: true },
        customers: { type: Array, default: () => [] },
        errors: { type: Object, default: () => ({}) },
    },
    methods: {
        normalizeSize,
    },
    computed: {
        modalTitle() {
            return this.isEditMode ? this.$t('groups.editTitle') : this.$t('groups.addTitle')
        },
    },
}
</script>

<style scoped>
.borderInput {
    border: 1px solid #9c9af880 !important;
}
</style>
